import React from 'react';
import SchedulingStepsHeader from '../SchedulingStepsHeader';
import { Layout } from 'antd';
import './MainLayout.less';

const MainLayout = ({ children, showSteps = true, className = '', ...layoutProps }) => (
    <Layout {...layoutProps} className={`main-layout ${className}`.trim()}>
        {showSteps ? <SchedulingStepsHeader /> : null}
        {children}            
    </Layout>
)

export default MainLayout
